import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { usePermission, useTranslation } from "src/hooks";
import { FeatureCodes } from "src/utils/constant";
import { useGenGridCol } from "src/utils/HelperComp";
import useOperationCell from "./useOperationCell";
import { TableColumnKey } from "../types/Table";

const editPermission =
  FeatureCodes.assetManagement.ContractSweepRecipentSetting
    .ContractSweepRecipentGroup.edit;
const deletePermission =
  FeatureCodes.assetManagement.ContractSweepRecipentSetting
    .ContractSweepRecipentGroup.delete;

const useTableColumns = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  const { renderOperationCell, renderDialogInOperationCell } =
    useOperationCell();

  const renderDialogInTableRow = () => {
    return <>{renderDialogInOperationCell()}</>;
  };

  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationCell,
      minWidth: 190,
    }),
    useGenGridCol(
      TableColumnKey.GroupSequence,
      t(TableColumnKey.GroupSequence),
    ),
    useGenGridCol(TableColumnKey.GroupName, t(TableColumnKey.GroupName), {
      minWidth: 150,
    }),
    useGenGridCol(TableColumnKey.GroupType, t(TableColumnKey.GroupType)),
    useGenGridCol(TableColumnKey.Status, t(TableColumnKey.Status)),
    useGenGridCol(TableColumnKey.Active, t(TableColumnKey.Active)),
    useGenGridCol(TableColumnKey.Valid, t(TableColumnKey.Valid)),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(TableColumnKey.Currency, t(TableColumnKey.Currency)),
    useGenGridCol(
      TableColumnKey.MaximumAmountLimit,
      t(TableColumnKey.MaximumAmountLimit),
      {
        minWidth: 150,
      },
    ),
    useGenGridCol(
      TableColumnKey.RotateAmountLimit,
      t(TableColumnKey.RotateAmountLimit),
      {
        minWidth: 160,
      },
    ),
    // useGenGridCol(TableColumnKey.CreatedBy, t(TableColumnKey.CreatedBy), {
    //   minWidth: 150,
    // }),
    useGenGridCol(TableColumnKey.CreationTime, t(TableColumnKey.CreationTime), {
      minWidth: 150,
    }),
    useGenGridCol(
      TableColumnKey.LastModifiedTime,
      t(TableColumnKey.LastModifiedTime),
      { minWidth: 150 },
    ),
  ].filter((col) => {
    if (
      col.field === TableColumnKey.Operation &&
      (!hasPermission(editPermission) || !hasPermission(deletePermission))
    ) {
      return false;
    }
    return true;
  });
  return { columns, renderDialogInTableRow };
};

export default useTableColumns;
